<style>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 50px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  justify-content: flex-start;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}
</style>
<meta
  http-equiv="Cache-Control"
  content="no-cache, no-store, must-revalidate"
/>
<meta http-equiv="Pragma" content="no-cache" />
<meta http-equiv="Expires" content="0" />
<template>
  <div class="flex-col page">
    <div class="flex-col flex-auto group_2 space-y-6">
      <div class="flex-col section">
        <div class="flex-col group_3">
          <div class="flex-col group_4">
            <div class="flex-row group_5 space-x-6">
              <img
                class="self-start image_4"
                src="../../assets/images/icon_result_header.png"
              />
              <div
                class="flex-col justify-start items-end flex-auto relative group_6"
              >
                <div
                  class="flex-col justify-start items-center image-wrapper"
                ></div>
                <span class="text_2 pos_2">您的咨询提交成功，订单受理中</span>
                <span class="text_3 pos_3"
                  >请保持电话畅通，以免错过审核电话</span
                >
              </div>
            </div>
            <div class="flex-col relative section_2">
              <div class="flex-col justify-start text-wrapper">
                <span class="text_4"
                  >以下产品已提交审核，将会有机构顾问与您取得联系，请您保持手机畅通。</span
                >
              </div>
              <div class="flex-row justify-between items-center group_7">
                <div class="flex-row items-center space-x-8">
                  <img class="shrink-0 image_5" :src="logoSrc" alt="" />
                  <span class="font_1 text_5">{{
                    apiProduct.name || "未获取产品名称"
                  }}</span>
                </div>
                <span class="font_2 text_6">机构代码：207</span>
              </div>
              <span class="self-start font_1 text_7">
                {{ apiProduct.companyName || "未获取公司名称" }}</span
              >
              <span class="font_2 text_8"
                >*此额度需要机构/资方电话复审（一小时内）请注意接听电话</span
              >
            </div>
          </div>
        </div>
        <div class="flex-col justify-start section_4">
          <div class="flex-col relative section_3 space-y-28">
            <div class="self-center group_9">
              <span class="font_3"> — </span>
              <span class="text_9">选择我们的理由</span>
              <span class="font_3"> — </span>
            </div>
            <div class="grid">
              <div
                class="flex-row items-start justify-center items-center grid-item space-x-6"
              >
                <img
                  class="shrink-0 image_6"
                  src="../../assets/images/model8/reason1.png"
                />
                <div class="flex-col items-start flex-auto space-y-10">
                  <span class="font_1 text_11">安全</span>
                  <span class="font_2">持牌金融机构合作</span>
                </div>
              </div>
              <div
                class="flex-row justify-center items-center grid-item space-x-6"
              >
                <img
                  class="image_6"
                  src="../../assets/images/model8/reason2.png"
                />
                <div class="flex-col items-start space-y-10">
                  <span class="font_1 text_11">放款</span>
                  <span class="font_2">最快5分钟放款</span>
                </div>
              </div>
              <div
                class="flex-row items-center items-center grid-item space-x-6"
              >
                <img
                  class="shrink-0 image_6"
                  src="../../assets/images/model8/reason3.png"
                />
                <div class="flex-col items-start flex-auto space-y-10">
                  <span class="font_1 text_11">灵活</span>
                  <span class="font_2">无年费 无套路</span>
                </div>
              </div>
              <div
                class="flex-row justify-center items-center grid-item_2 space-x-6"
              >
                <img
                  class="image_6"
                  src="../../assets/images/model8/reason4.png"
                />
                <div class="flex-col items-start space-y-8">
                  <span class="font_1 text_11">额度</span>
                  <span class="font_2">最高可借20万</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col section_5">
        <div
          class="flex-col justify-start items-center button"
          v-on:click="handleDownload"
        >
          <span class="text_14">{{ btnTxt }}</span>
        </div>
        <div class="apply_group_10">
          <span class="font_4 text_16">温馨提示：</span>
          <span class="font_4 text_17"><br /></span>
          <span class="font_4 text_15">
            为您提供贷款咨询推荐服务,在使用服务过程中遇到的任何预先收费,网络转账、素要银行卡密码、素要手机验证码行为均有诈骗风险,请保持警惕避免损失。同时您知愿您已授权安信花基于向您推荐货款資询服务之目的,将您的个人信息提供给贷款咨询服务机构,请特别关注机构是否按照您的授权使用您的个人信息并向您提供贷款咨询服务。
          </span>
        </div>
      </div>
    </div>
    <!--    协议弹窗-->
    <div class="po_section_1 flex-col po_bg" v-show="isShowProtocol">
      <div class="po_block_1 flex-col">
        <div class="po_box_1 flex-col">
          <img
            class="po_thumbnail_1"
            referrerpolicy="no-referrer"
            src="../../assets/images/model8/model8_po_close.png"
            v-on:click="handelCloseProtocol"
          />
          <div class="po_text-group_1 flex-col justify-between">
            <span class="po_text_1">请阅读以下协议</span>
          </div>
          <div class="flex-col po_content justify-between">
            <span class="contentText" v-html="apiProduct.content"> </span>
          </div>
          <button
            class="po_button_1 flex-col"
            @click="handelAgreeProtocol"
            v-prevent-reclick
          >
            <span class="po_text_2">我已阅读并同意授权</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API_Common from "@/api/common.js";
import {
  addDownloadRecord,
  toRedirectUrlAndSaveRecordNoDebounce,
} from "@/api/common.js";

//匹配到头部api 跳转的界面
export default {
  name: "apiApplyResults",
  data() {
    return {
      model: sessionStorage.getItem("model"),
      channel: this.$route.query.source,
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        productName: "",
        userId: "",
        content: "",
      },
      unionLogin: {
        productId: 0,
        url: "",
      },
      timer: undefined,
      timerCount: 3,
      downAppUrl: "",
      btnTxt: " ",
      recommendProduct: {}, //推荐产品 如果是惠利花展示到落地页
      productName: "",
      companyName: "",
      imageUrl: "",
      isShowProtocol: false,
    };
  },

  mounted() {
    this.getDownloadUrl();
    this.getAPIProduct();
    this.getIsShieldCity();
  },
  computed: {
    logoSrc() {
      return (
        this.apiProduct.imgUrl || require("../../../public/fangxin_logo.png")
      );
    },
  },
  methods: {
    getDownloadUrl() {
      //不考虑海尔
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url;
        }
      });
    },
    //获取是否屏蔽城市
    async getIsShieldCity() {
      try {
        const res = await API_Common.getIsShieldCity(this.channel);
        // 响应有效性检查
        if (!res || res.code !== 200) {
          this.defaultDisplayData();
          return;
        }
        // 城市屏蔽状态处理
        res.data === false
          ? await this.getChannleProductList()
          : this.defaultDisplayData();
      } catch (error) {
        this.defaultDisplayData();
      }
    },

    // 根据渠道code读取产品推荐信息 仅展示惠利花
    async getChannleProductList() {
      try {
        const res = await API_Common.getProductsInResultPage(this.channel);
        if (res.code !== 200) {
          this.defaultDisplayData();
          return;
        }
        const dataArr = res.data || [];
        if (dataArr.length === 0) {
          this.defaultDisplayData();
          return;
        }
        // 查找名称包含"惠利花"的产品
        const huiLiHuaProduct = dataArr.find(
          (item) => item.name && item.name.includes("惠利花")
        );
        if (huiLiHuaProduct) {
          this.recommendProduct = huiLiHuaProduct;
          this.btnTxt = "立即提现";
        } else {
          this.defaultDisplayData();
          return;
        }
        // 处理注册协议
        if (this.recommendProduct.isToRegister === 1) {
          await this.fetchRegistrationAgreement();
        }
      } catch (error) {
        console.error("获取产品列表失败:", error);
        this.defaultDisplayData();
      }
    },

    // 提取获取注册协议为独立方法
    async fetchRegistrationAgreement() {
      try {
        const pageType = this.model === "modeldlb" ? 36 : 40;
        const res = await API_Common.getContent({ pageType });
        if (res.data) {
          this.apiProduct.content = res.data.content;
        }
      } catch (error) {
        console.error("获取注册协议失败:", error);
      }
    },

    //API机构和授权书
    async getAPIProduct() {
      try {
        const res = await API_Common.getUser2WhereApi();
        if (res.code === 200) {
          this.apiProduct = {
            ...this.apiProduct,
            ...(res.data || {}),
          };
          this.productName = this.recommendProduct.name;
          this.companyName = this.recommendProduct.companyName;
          this.imageUrl = this.recommendProduct.imgUrl;
        }
      } catch (error) {
        this.$toast("网络请求失败，请稍后重试");
        this.apiProduct = {};
      }
    },
    handelAgreeProtocol() {
      this.isShowProtocol = false;
      const buriedData = {
        productId: this.recommendProduct.id,
        showPage: 5,
      };
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            that.unionLogin = res.data;
          })
          .catch((error) => {})
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                productId: this.recommendProduct.id,
                showPage: 5,
              },
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },
    handleDownload() {
      addDownloadRecord(this.channel);
      if (this.recommendProduct?.name?.includes("惠利花")) {
        this.isShowProtocol = true;
      } else {
        clearInterval(this.timer);
        window.location.href = this.downAppUrl;
      }
    },
    //如果有惠利花cpa产品 不自动下载 按钮改为立即申请 点击跳转惠利花
    handleAutoDownload() {
      this.timer = setInterval(() => {
        this.timerCount -= 1;
        this.btnTxt = `下载APP查看审核结果(${this.timerCount}s)`; // 手动更新
        if (this.timerCount <= 0) {
          clearInterval(this.timer);
          window.location.href = this.downAppUrl;
        }
      }, 1000);
    },
    // 关闭协议弹窗
    handelCloseProtocol() {
      this.isShowProtocol = false;
    },
    defaultDisplayData() {
      this.recommendProduct = {};
      this.btnTxt = `下载APP查看审核结果(${this.timerCount}s)`;
      this.handleAutoDownload();
      this.productName = this.apiProduct.name ?? this.apiProduct.productName;
      this.companyName = this.apiProduct.companyName;
      this.imageUrl = this.apiProduct.imgUrl;
    },
  },
};
</script>
<style scoped>
@import "../../css/model8PopView.css";
@import "../../css/protocolPopView.css";
</style>
<style scoped lang="css">
.page {
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;
  position: relative;
}
.space-y-12 > *:not(:first-child) {
  margin-top: 0.24rem;
}
.group_2 {
  overflow-y: auto;
}
.space-y-6 > *:not(:first-child) {
  margin-top: 0.12rem;
}
.section {
  padding-top: 0.44rem;
  background-image: url("../../assets/images/model8/bg.png");
  border-radius: 0.02rem;
}
.group_3 {
  padding-left: 0.3rem;
  height: 5.1rem;
}
.group_4 {
  height: 4.91rem;
}
.group_5 {
  padding-left: 0.82rem;
}
.image_4 {
  width: 0.68rem;
  height: 0.68rem;
}
.group_6 {
  margin-right: -1.2rem;
}
.image-wrapper {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 3.44rem;
  margin-left: 3.2rem;
}
.image_3 {
  filter: drop-shadow(0.28rem 0.18rem 0.09rem #1c7bf5);
  width: 3.44rem;
  height: 3.2rem;
}
.text_2 {
  color: #000000;
  font-size: 0.32rem;
  font-family: SourceHanSansSC;
  line-height: 0.31rem;
}
.pos_2 {
  position: absolute;
  left: 1.9rem;
  top: 0.6rem;
}
.text_3 {
  color: #000000;
  font-size: 0.24rem;
  font-family: SourceHanSansSC;
  line-height: 0.23rem;
}
.pos_3 {
  position: absolute;
  left: 1.9rem;
  top: 1.1rem;
}
.section_2 {
  margin-right: 0.3rem;
  margin-top: -2rem;
  padding-bottom: 0.52rem;
  background-color: #ffffff;
  border-radius: 0.16rem;
}
.text-wrapper {
  padding-top: 0.24rem;
  background-color: #ffffff;
  border-radius: 0.16rem 0.16rem 0px 0px;
  height: 1.08rem;
  border-bottom: solid 0.04rem #eeeeee;
}
.text_4 {
  margin-left: 0.32rem;
  margin-right: 0.4rem;
  color: #d93c3a;
  font-size: 0.26rem;
  font-family: PingFangSC;
  line-height: 0.32rem;
}

.group_7 {
  margin-top: 0.4rem;
  padding: 0 0.24rem;
}
.space-x-8 > *:not(:first-child) {
  margin-left: 0.16rem;
}
.image_5 {
  filter: drop-shadow(0px 0.04rem 0.04rem #91919130);
  width: 0.48rem;
  height: 0.48rem;
  background-size: cover; /* 图片覆盖整个元素 */
  background-repeat: no-repeat; /* 不重复 */
  background-position: center; /* 居中显示 */
  display: inline-block; /* 确保背景图能正常显示 */
}
.font_1 {
  font-size: 0.3rem;
  font-family: PingFangSC;
  line-height: 0.4rem;
}
.text_5 {
  line-height: 0.3rem;
}
.font_2 {
  font-size: 0.24rem;
  font-family: PingFangSC;
  line-height: 0.24rem;
  color: #999999;
}
.text_6 {
  font-size: 0.26rem;
  line-height: 0.26rem;
}
.text_7 {
  margin-left: 0.24rem;
  margin-top: 0.2rem;
  color: #333333;
  font-size: 0.28rem;
}
.text_8 {
  margin-left: 0.24rem;
  margin-top: 0.24rem;
  color: #bbbbbb;
  line-height: 0.24rem;
}
.group_8 {
  margin-right: 0.3rem;
  margin-top: -0.38rem;
  border-radius: 0px 0px 0.16rem 0.16rem;
  height: 0.74rem;
}
.section_4 {
  padding-bottom: 0.1rem;
  background-image: linear-gradient(180deg, #f9f9f900 0%, #f5f8ff 100%);
  border-radius: 0.02rem;
  margin-top: -0.2rem;
}
.section_3 {
  margin: 0.2rem 0.3rem 0;
  padding: 0.52rem 0 0.28rem;
  background-color: #ffffff;
  border-radius: 0.16rem;
}
.space-y-28 > *:not(:first-child) {
  margin-top: 0.56rem;
}
.group_9 {
  line-height: 0.3rem;
}
.font_3 {
  font-size: 0.42rem;
  font-family: PingFangSC;
  line-height: 0.03rem;
  font-weight: 100;
  color: #d93c3a;
}
.text_9 {
  color: #d93c3a;
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 0.32rem;
}
.grid {
  height: 2.58rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 0.36rem;
  column-gap: 0.36rem;
}
.grid-item {
  padding: 0 0.34rem 0.32rem;
}
.image_6 {
  width: 0.8rem;
  height: 0.8rem;
}
.image_7 {
  margin-top: 0.28rem;
}
.space-y-10 > *:not(:first-child) {
  margin-top: 0.2rem;
}
.text_10 {
  line-height: 0.4rem;
}
.grid-item_2 {
  padding: 0 0.34rem 0.32rem;
}
.space-x-6 > *:not(:first-child) {
  margin-left: 0.12rem;
}
.text_11 {
  line-height: 0.3rem;
}
.grid-item_3 {
  padding: 0 0.34rem 0.32rem;
}
.text_12 {
  line-height: 0.28rem;
}
.space-x-4 > *:not(:first-child) {
  margin-left: 0.08rem;
}
.text_13 {
  margin-top: 0.16rem;
}
.space-y-8 > *:not(:first-child) {
  margin-top: 0.16rem;
}
.section_5 {
  padding: 0.44rem 0.3rem 0.72rem;
  background-color: #f5f8ff;
}
.button {
  padding: 0.3rem 0 0.3rem;
  background-color: #d93c3a;
  height: 1rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.text_14 {
  color: #ffffff;
  font-size: 0.3rem;
  font-family: PingFangSC;
  line-height: 0.39rem;
}
.apply_group_10 {
  margin: 0.44rem 0.08rem 0 0.04rem;
  line-height: 0.26rem;
  font-size: 0px;
}
.font_4 {
  font-size: 0.24rem;
  font-family: PingFangSC;
  line-height: 0.26rem;
  color: #c2c2c2;
}
.text_16 {
  color: #d93c3a;
  font-size: 0.22rem;
}
.text_17 {
  font-size: 0.22rem;
}
.text_15 {
  font-size: 0.22rem;
}
.self-center {
  align-self: center;
}
.icon-download {
  width: 6.8rem;
  height: 7.3rem;
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
